import { render, staticRenderFns } from "./MdtkList.vue?vue&type=template&id=4042c6d9&scoped=true&"
import script from "./MdtkList.vue?vue&type=script&lang=js&"
export * from "./MdtkList.vue?vue&type=script&lang=js&"
import style0 from "./MdtkList.vue?vue&type=style&index=0&id=4042c6d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4042c6d9",
  null
  
)

export default component.exports